// export const OTHER = 11;
export const  OTHER_ID:number |undefined = 11;
export const  WRONG_TEST_CENTRE:number |undefined = 8;
export const  CLASH_TEST:number |undefined = 6;
export const  TOO_SOON:number |undefined = 7;
export const  OUTSIDE_WORKING_HOURS:number |undefined = 9;
export const  VACATION:number |undefined = 10;